import React from "react"
import { Dialog } from "@carrotfertility/carotene-core"
import { StateMachineProvider, StateMachineStepView } from "#/components/context/stateMachine/StateMachineV2"
import { useUserRole } from "#/components/partner-access/hooks/usePartnerAccess"
import { OriginDialogContext } from "#/components/telemedicine/pelvic-floor-therapy/OriginDialogContext"
import {
  Steps,
  telemedicineForPelvicFloorTherapySteps,
  telemedicineForPelvicFloorTherapyWorkflows,
  Workflows
} from "#/components/telemedicine/pelvic-floor-therapy/workflow"

export interface AccessOriginAccountDialogProps {
  open: boolean
  onClose: () => void
}

enum Sections {
  TELEMEDICINE_FOR_PELVIC_FLOOR_THERAPY = "TelemedicineForPelvicFloorTherapy"
}

export function AccessOriginAccountDialog({ open, onClose }: AccessOriginAccountDialogProps): JSX.Element {
  const { isPartnerAccessingAccount } = useUserRole()

  const telemedicineForPelvicFloorTherapy = {
    name: Sections.TELEMEDICINE_FOR_PELVIC_FLOOR_THERAPY,
    initialStep: Steps.WHO_WILL_RECEIVING_CARE,
    desiredWorkflow: isPartnerAccessingAccount
      ? Workflows.TELEMEDICINE_FOR_PELVIC_FLOOR_THERAPY_PARTNER
      : Workflows.TELEMEDICINE_FOR_PELVIC_FLOOR_THERAPY_MEMBER,
    steps: telemedicineForPelvicFloorTherapySteps,
    workflows: telemedicineForPelvicFloorTherapyWorkflows
  }

  const setOpenDialogFlow = (shouldBeOpen: boolean) => {
    if (!shouldBeOpen) {
      onClose()
    }
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <StateMachineProvider
        initialSection={Sections.TELEMEDICINE_FOR_PELVIC_FLOOR_THERAPY}
        stateMachineDescription={[telemedicineForPelvicFloorTherapy]}
        onComplete={null}
      >
        <OriginDialogContext.Provider value={{ openDialogFlow: open, setOpenDialogFlow }}>
          <StateMachineStepView />
        </OriginDialogContext.Provider>
      </StateMachineProvider>
    </Dialog>
  )
}
